import { render, staticRenderFns } from "./ExcInput.vue?vue&type=template&id=2b3af56c&scoped=true&"
import script from "./ExcInput.vue?vue&type=script&lang=js&"
export * from "./ExcInput.vue?vue&type=script&lang=js&"
import style0 from "./ExcInput.vue?vue&type=style&index=0&id=2b3af56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3af56c",
  null
  
)

export default component.exports